import { useTranslation } from "react-i18next";
import type { UtilityMode } from "../types";
import { useDiscoverContext } from "../state/discover-context";
import { useDiscoverConfig } from "../config";
import { useLikedItems } from "../hooks/use-liked-items";
import { DiscoverBrowser } from "./discover-browser";
import { DiscoverStage } from "./discover-stage";
import { DiscoverCard } from "./discover-card";
import { TripPlanner } from "./trip-planner/trip-planner";

const MODE_CLASS: Record<UtilityMode, string> = {
  explore: "",
  cities: "is-cities-mode",
  trips: "is-trips-mode",
  liked: "is-liked-mode",
  chat: "is-chat-mode",
};

export function DiscoverMain() {
  const { t } = useTranslation();
  const { state } = useDiscoverContext();
  const { features } = useDiscoverConfig();
  const likedItems = useLikedItems();
  const mode = state.utilityMode;
  const modeClass = MODE_CLASS[mode];

  return (
    <div
      className={`mj-discover-main${modeClass ? ` ${modeClass}` : ""}`}
      // Chat mode only: the guest sets how much of the row the map takes, and
      // the two columns are siblings, so the width has to be published here.
      data-chat-map={mode === "chat" ? state.chatMapSize : undefined}
    >
      {(mode === "explore" || mode === "cities") && (
        <>
          <DiscoverBrowser />
          <DiscoverStage />
        </>
      )}

      {mode === "trips" && <TripPlanner />}

      {mode === "liked" && (
        <div className="mj-discover-panel mj-discover-liked">
          <header className="mj-discover-liked__header">
            <h2>{t("discover.liked_picks")}</h2>
            <p>
              {likedItems.length === 0
                ? t("discover.liked_empty_hint")
                : t("discover.liked_count", { count: likedItems.length })}
            </p>
          </header>
          {likedItems.length > 0 && (
            <div className="mj-discover-browser__grid">
              {likedItems.map((item) => (
                <DiscoverCard key={item.id} item={item} />
              ))}
            </div>
          )}
        </div>
      )}

      {mode === "chat" && (
        <>
          {features?.aiChat}
          <DiscoverStage />
        </>
      )}
    </div>
  );
}
